import styles from './ViewModeBar.module.css';

export type ViewMode = 'byPhase' | 'timeline' | 'byAuthor';

interface ViewModeBarProps {
  mode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
  totalContributions: number;
  totalAuthors: number;
}

const MODE_LABELS: Record<ViewMode, string> = {
  byPhase: 'By Phase',
  timeline: 'Timeline',
  byAuthor: 'By Author',
};

const MODES: ViewMode[] = ['byPhase', 'timeline', 'byAuthor'];

export function ViewModeBar({ mode, onModeChange, totalContributions, totalAuthors }: ViewModeBarProps) {
  return (
    <div class={styles.bar}>
      <div class={styles.pills}>
        {MODES.map((m) => (
          <button
            key={m}
            type="button"
            class={`${styles.pill} ${m === mode ? styles.pillActive : ''}`}
            onClick={() => onModeChange(m)}
          >
            {MODE_LABELS[m]}
          </button>
        ))}
      </div>
      <span class={styles.count}>
        {totalContributions} {totalContributions === 1 ? 'take' : 'takes'} from {totalAuthors} {totalAuthors === 1 ? 'person' : 'people'}
      </span>
    </div>
  );
}
